import { useState } from "react";
import { Button } from "primereact/button";

import PrimeDialog from "../../../components/dialog/PrimeDialog";
import { AddAbandoned } from "./dialog/AddAbandoned";
import { useForm } from "react-hook-form";

export const Abandoned = () => {
    const [addDialog,setAddDialog] = useState(false);
    const { getValues, 
        setValue, 
        control,
        clearErrors, 
        register, 
        handleSubmit, 
        formState: { errors,isValid } } = useForm({
    defaultValues: {
     
    },
     //錯誤驗證時機
    mode: "all"
  })
    return(<>
        <Button label="新增" onClick={()=>setAddDialog(true)}></Button>
        <PrimeDialog
        visible={addDialog}
            title="新增"
            size="lg"
            onClose={() => { setAddDialog(false) }}
            onConfirm={() => { setAddDialog(false) }}
            bodyTemplate={
                <AddAbandoned
                    register = {register}
                    errors = {errors}
                    control = {control}
                    setValue = {setValue}
                ></AddAbandoned>}
            ></PrimeDialog>
    </>)
}